import { selectLocationStatus, selectPlaces } from 'containers/Maps/Result/locationSlice'
import { selectPlaces as selectMapPlaces } from 'containers/Maps/Map/mapSlice'
import { addFilters, selectFilters } from 'containers/Maps/menu/filtersSlice'
import PlaceElementForList from 'containers/Maps/Result/PlaceElementForList'
import WarehouseAttrPopup from 'containers/Maps/Popups/WarehouseAttrPopup'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import SkeletonElement from 'containers/Maps/Result/SkeletonElement'
import AutomationPopup from 'containers/Maps/Popups/AutomationPopup'
import { Fragment, useEffect, useRef, useState } from 'react'
import SortSelect from 'containers/Maps/Result/SortSelect'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import ObjectDetails from '../ObjectDetails'
import { useSelector } from 'react-redux'
import { useReduxDispatch } from 'store'
import { STATUS } from 'utils/constants'
import MapDetails from '../MapDetails'
import Error from 'components/Error'

const List = () => {
  const places = useSelector(selectPlaces)
  const filters = useSelector(selectFilters)
  const mapPlaces = useSelector(selectMapPlaces)
  const status = useSelector(selectLocationStatus)
  const [isNarrow, setIsNarrow] = useState(false)

  const { popup } = usePopupState()
  const { pathname } = useLocation()
  const { placeId } = useParams<{ placeId?: string }>()

  const { goBack } = useHistory()
  const { t } = useTranslation('map')
  const dispatch = useReduxDispatch()

  const containerRef = useRef(null)

  //Dynamiczna zmiana ilości kolumn z lewej strony
  useEffect(() => {
    const element = containerRef.current
    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        setIsNarrow(entry.contentRect.width < 500)
      }
    })

    if (element) {
      observer.observe(element)
    }

    return () => {
      observer.disconnect()
    }
  }, [pathname])


  if (pathname.includes('mapdetails')) {
    return (
      <MapDetails />
    )
  }

  return (
    <>
      {(popup as any)?.type === 'warehouse_attr' && (popup as any)?.place_attrs && <WarehouseAttrPopup body={(popup as any)?.place_attrs} />}
      {(popup as any)?.type === 'automation' && (popup as any)?.automation && <AutomationPopup body={(popup as any)?.automation} />}
      {placeId
        ? <div className="search__left">
          <div className="search__left__title">
            <div>
              <h2>{t('selectedYard')}</h2>
            </div>
            <ArrowBtn text={t('backToList')} action={goBack} className='--reverse --black' />
          </div>
          <div className="search__left__content">
            <ObjectDetails
              data={mapPlaces?.find((place: any) => place?.id === placeId)}
              warehouseTypeId={filters?.attributes?.warehouseTypeId || ''}
            />
          </div>
        </div>
        : <div className="search__left" ref={containerRef}>
          <div className="search__left__title">
            <div>
              <h2>
                {places?.filteredAndLocalized
                  ? places?.filteredAndLocalized?.length > 0
                    ? `${t('foundItems')} (${places.filteredAndLocalized.length})`
                    : t('noResults')
                  : t('loading')}
              </h2>
            </div>
            {getAmountOfPlaces(places) > 0
              ? <SortSelect />
              : <button
                className='btn--clear'
                onClick={() => {
                  dispatch(addFilters({}))
                }}>
                {t('clearFilters')}
              </button>}
          </div>
          <div
            className="search__left__content"
            style={{
              gridTemplateColumns: isNarrow ? "1fr" : "1fr 1fr"
            }}>
            {status === STATUS.pending
              ? [1, 2, 3].map(e => <SkeletonElement key={e} isDesktop />)
              : status === STATUS.succeed
                ? Object.entries(places).map(([k, _v]) => {
                  const v = _v as any[]
                  const title = k === 'filtered' && v.length > 0 ? (
                    <div className='list__header'>
                      <span>{t('seeOtherLocations')}</span>
                      <i className='icon icon--chevron-down' />
                    </div>
                  ) : k === 'localized' && v.length > 0 ? (
                    <div className='list__header'>
                      <span>{t('seeOtherOptions')}</span>
                      <i className='icon icon--chevron-down' />
                    </div>
                  ) : false

                  const elements = v.map((e, idx) => <PlaceElementForList
                    isDesktop={true}
                    data={e}
                    key={idx}
                    idx={idx}
                    warehouseTypeId={filters?.attributes?.warehouseTypeId}
                  />)

                  return <Fragment key={k}>
                    {title}
                    {v.length > 0 && elements}
                  </Fragment>
                }) : <Error text={'🤧'} />}
          </div>
        </div>}
    </>
  )
}

const getAmountOfPlaces = (places?: Record<string, object[]>) => {
  if (!places) return 0
  return Object.values(places).reduce((r, e) => r + e.length, 0)
}

export default List